/**
 * Split locale string at _ or - char. Used to extract language and
 * country code from xx_XX locale format.
 * @param {string} locale
 * @return {array} locale split at - or _, or empty array []
 */
const getSplitLocale = locale => (typeof locale === 'string' && locale.split(/_|-/)) || [];
export default getSplitLocale;
